module.exports = __webpack_public_path__ + "img/mypage_profile.a68b8e15.png";